import { Realty, services } from '@ambita/ambita-components-core';

const { util } = services;

const transformPerson = function (personResponse: Realty.ApiResponse): any {
  if (personResponse.item) {
    const person: Realty.ApiPerson = personResponse.item;
    const returnObject: any = util.pick(person, [
      'name',
      'businessAddress',
      'personalNumber',
      'birthday',
      'organizationNumber',
      'businessType'
    ]);

    if (person.birthday) {
      const birthdayParts = person.birthday.replace('/', '').split('-');
      returnObject.shortPersonalNumber = birthdayParts[0] + birthdayParts[1].substr(2, 2);
    }

    if (person.dsfState) {
      returnObject.dsfState = person.dsfState.text;
    }

    if (person.location) {
      returnObject.location = util.pick(person.location, [
        'addressNumber',
        'letter',
        'postalCode',
        'postalPlace',
        'street'
      ]);
    }

    return returnObject;
  }
};

export default transformPerson;
